import { combineReducers } from 'redux';
import headerReducer from './header-reducer';
const rootReducer = () => {
  return combineReducers({ headerReducer });
};
export default rootReducer;
